import { render } from "./NavbarPage.vue?vue&type=template&id=0e8d2997"
import script from "./NavbarPage.vue?vue&type=script&lang=js"
export * from "./NavbarPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__